import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { of } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { OidcService } from '../../shared/services/oidc/oidc.service';

export const AccountGuard: CanActivateFn = () => {
    const oidcService: OidcService = inject(OidcService);
    const router: Router = inject(Router);

    return oidcService.isLoginDetectable$().pipe(

        switchMap(() => oidcService.authToken$),
        switchMap((token) => {
            if (!token) {
                oidcService.login();
                return of(false);
            }
            return of(true);
        })
    );
};
